import React from 'react';
import { Moment } from '@kineticdata/react';

export const DateCell = ({ value }) => (
  <td>
    {value && (
      <Moment timestamp={value} format={Moment.formats.dateTimeWithSeconds} />
    )}
  </td>
);
